define('plugin/category/model/CategoryModel',['require','lib/model/BaseModel'],function (require) {
	
	var BaseModel = require('lib/model/BaseModel');
	
	/**
	 * Category info model
	 * 
	 * @class CategoryModel
	 */
	return BaseModel.extend({
		
		defaults: {
			id: '',
			description: '',
			title: ''
		}
		
	});
	
});
